<template>
  <v-card>
    <v-card-title>
      {{item.name}}
      <v-spacer></v-spacer>
      <v-btn :loading="loading" @click="$emit('close')" fab x-small color="secondary"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <!-- <v-form> -->
    <v-card-text class="pt-2">
      <v-row>
        <v-col cols="5">
          <v-img v-if="item.image" :src="`${this.$store.getters.url}/media/image/${item.image}?size=lg`">
            <v-badge top left color="warning" overlap dot :value="item.image != original_value.image">
              <v-btn class="ma-2" small color="secondary" fab @click="item.image = null"><v-icon>mdi-delete</v-icon></v-btn>
            </v-badge>
          </v-img>
          <ImageCropper 
            v-else
            @results="onImageData"
            :aspectRatio="1"
          />
          <v-container fluid>
            <v-row>
              <v-col>
                <InfoField :label="$t('Идентификатор')" class="mt-5">
                  {{item.id}}
                </InfoField>
              </v-col>
              <v-col>
                <InfoField :label="$t('Путь по группам')" class="mt-5">
                  {{item.categ_path}}
                </InfoField>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <InfoField :label="$t('Остаток порций')">
                  {{item.leftovers || $t('Не ограничено')}}
                </InfoField>
              </v-col>
              <v-col>
                <InfoField :label="$t('Время приготовления')">
                  {{item.cook_mins || $t('Не задано')}}
                </InfoField>
              </v-col>
            </v-row>
            <v-row v-if="item.prices.delivery === item.prices.takeaway">
              <v-col>
                <InfoField :label="$t('Базовая стоимость')">
                  {{ (+item.prices.delivery).toFixed(2) }}
                </InfoField>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col>
                <InfoField :label="$t('Стоимость для доставки')">
                  {{item.prices.delivery ? (+item.prices.delivery).toFixed(2) : $t('Не задано')}}
                </InfoField>
              </v-col>
              <v-col>
                <InfoField :label="$t('Стоимость для самовывоза')">
                  {{item.prices.takeaway ? (+item.prices.takeaway).toFixed(2) : $t('Не задано')}}
                </InfoField>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col cols="7">
          <TextField :rules="[ruleRequireValue]" clearable :label="$t('Альтернативное название')" :hint="$t('Альтернативное название будет отображаться в интернет магазине')" v-model="item.alt_name" counter="100" :original_value="original_value.alt_name" />
          <v-row dense>
            <v-col>
              <TextField :rules="[ruleRequireValue]" type="number" clearable :label="$t('Белки')" :hint="$t('Задайте содержание белков')" v-model="item.proteins" :original_value="original_value.proteins" />
            </v-col>
            <v-col>
              <TextField :rules="[ruleRequireValue]" type="number" clearable :label="$t('Жиры')" :hint="$t('Задайте содержание жиров')" v-model="item.fats" :original_value="original_value.fats"/>
            </v-col>
            <v-col>
              <TextField :rules="[ruleRequireValue]" type="number" clearable :label="$t('Углеводы')" :hint="$t('Задайте содержание углеводов')" v-model="item.carbohydrates" :original_value="original_value.carbohydrates"/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <TextField :rules="[ruleRequireValue]" type="number" clearable :label="$t('Энергетическая ценность')" :hint="$t('Задайте энергетическую ценность')" v-model="item.energy" :original_value="original_value.energy">
                <template #append-outer v-if="item.proteins || item.fats || item.carbohydrates">
                  <v-btn :title="$t('Рассчитать')" small icon color="primary" @click="item.energy = calcEnergy(item.proteins, item.fats, item.carbohydrates)"><v-icon>mdi-calculator-variant-outline</v-icon></v-btn>
                </template>
              </TextField>
            </v-col>
          </v-row>
          <TextField :rules="[ruleRequireValue]" clearable :label="$t('Размер порции')" :hint="$t('Укажите пограммовку порции блюда')" v-model="item.volumes" :original_value="original_value.volumes" counter="100"/>
          <TextField :rules="[ruleRequireValue]" clearable :label="$t('Описание')" :hint="$t('Задайте описание блюда')" v-model="item.description" multiline :original_value="original_value.description" counter="400"/>
          <TextField :rules="[ruleRequireValue]" type="number" clearable :label="$t('Старая цена')" :hint="$t('Старая цена будет отображаться зачеркнутой рядом с актуальной')" v-model="item.previous_price" :original_value="original_value.previous_price" />
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="save" :loading="loading" type="submit" text color="primary"><T>Сохранить</T></v-btn>
    </v-card-actions>
    <!-- </v-form> -->
  </v-card>
</template>

<script>
import TextField from '../../common/TextField.vue'
import InfoField from '../../common/InfoField.vue'
import ImageCropper from '../../common/ImageCropper'

export default {
  props: ['item', 'original_value'],
  data: () => ({
    loading: false
  }),
  methods: {
    async save(){
      this.loading = true
      try {
        await this.$store.dispatch('updateMenuitem', this.item)
        this.$store.dispatch('throwTimeoutMessage', {
          message_data: this.$t('Изменения сохранены'),
          message_class: 'success'
        })
        this.$emit('close')
      } finally {
        this.loading = false
      }
    },
    async onImageData({image, crop}) {
      let form = new FormData();
      form.append('image', image)
      form.append('crop', JSON.stringify(crop))
      let r = await fetch(
        `${this.$store.getters.url}/media/image`, 
        {
          method: 'POST', 
          body: form
        }
      )
      r = await r.json()
      if (r.result) {
        this.item.image = r.data
      }
    },
    ruleRequireValue() {
      // console.log(v)
      // if (v !== null) {
      //   if (v === '') {
          
      //     return this.$t('Если вы хотите оставить поле пустым, очистите значение с помощью крестика в правой части поля')
      //   } else {
      //     return true
      //   }
      // } else {
        return true
      // }
    },
    calcEnergy(prot, fats, carbos) {
      return Math.round((+prot || 0)*4 + (+fats || 0)*9 + (+carbos || 0)*3)
    }
  },
  components: {
    TextField,
    InfoField,
    ImageCropper
  }
}
</script>